const results = [
  {
    icon: 'ri-heart-pulse-line',
    title: 'Рост доверия',
    desc: 'Сотрудники начинают открыто делиться информацией, признавать ошибки и просить помощь.',
  },
  {
    icon: 'ri-chat-smile-2-line',
    title: 'Лучше коммуникация',
    desc: 'Информация передается быстро и точно. Обратная связь становится нормой, а не угрозой.',
  },
  {
    icon: 'ri-time-line',
    title: 'Быстрее решения',
    desc: 'Команда принимает решения быстрее, потому что процесс обсуждения становится прозрачным.',
  },
  {
    icon: 'ri-emotion-happy-line',
    title: 'Меньше конфликтов',
    desc: 'Конфликты решаются на ранней стадии. Команда учится договариваться и находить компромиссы.',
  },
  {
    icon: 'ri-fire-line',
    title: 'Выше вовлеченность',
    desc: 'Сотрудники предлагают идеи, берут инициативу и работают на общий результат, а не «от и до».',
  },
  {
    icon: 'ri-line-chart-line',
    title: 'Выше производительность',
    desc: 'Меньше времени тратится на внутренние разборки. Больше — на результат.',
  },
  {
    icon: 'ri-sun-line',
    title: 'Лучшая атмосфера',
    desc: 'Люди хотят приходить на работу. Понятные правила, доверие и взаимопомощь.',
  },
  {
    icon: 'ri-vip-crown-line',
    title: 'Более сильные руководители',
    desc: 'Руководители учатся вести команду через доверие, а не через контроль и давление.',
  },
  {
    icon: 'ri-bar-chart-grouped-line',
    title: 'Рост эффективности бизнеса',
    desc: 'Измеримый рост ключевых показателей: скорость, качество, удовлетворенность клиентов.',
  },
];

export default function CompanyResults() {
  return (
    <section className="py-20 md:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <h2 className="text-3xl md:text-5xl font-bold text-gray-900 text-center mb-6">
          Что получает компания
        </h2>
        <p className="text-lg text-gray-600 text-center mb-16 max-w-3xl mx-auto leading-relaxed">
          Командообразование — это не расход, а инвестиция. Результаты измеряются и видны в бизнес-показателях.
        </p>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {results.map((r, i) => (
            <div key={i} className="bg-gray-50 rounded-xl p-6 border border-gray-100 hover:border-teal-300 transition-all group">
              <div className="w-12 h-12 bg-teal-600 rounded-lg flex items-center justify-center mb-4 group-hover:scale-110 transition-transform">
                <i className={`${r.icon} text-xl text-white`}></i>
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-2">{r.title}</h3>
              <p className="text-gray-600 text-sm leading-relaxed">{r.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}